import { __extends } from "tslib";
import * as React from 'react';
import withPlaybackContext from '../../common/withPlaybackContext';
import { classes } from './Rate.st.css';
var Rate = /** @class */ (function (_super) {
    __extends(Rate, _super);
    function Rate() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleChange = function () {
            // @ts-ignore
            var nextRate = _this.props.context.playbackRate + _this.props.increment; // tslint:disable-line
            // @ts-ignore
            nextRate = nextRate > _this.props.max ? _this.props.min : nextRate;
            _this.props.context.setPlaybackRate(nextRate);
        };
        return _this;
    }
    Rate.prototype.render = function () {
        return (React.createElement("button", { className: classes.button + " " + this.props.className, "data-hook": this.props.dataHook, onClick: this.handleChange },
            this.props.prefix,
            this.props.context.playbackRate,
            this.props.suffix));
    };
    Rate.displayName = 'Rate';
    Rate.defaultProps = {
        className: '',
        dataHook: '',
        increment: 0.5,
        max: 2,
        min: 0.5,
        prefix: '',
        suffix: 'x',
    };
    return Rate;
}(React.Component));
export default withPlaybackContext(Rate);
//# sourceMappingURL=Rate.js.map